module.exports = __webpack_public_path__ + "2fd11fde8ab1af1452d857d197d2fee9.MP3";